export const RELACIONES = [
  "Paciente", "Padre", "Madre", "Familiar", "Médico", "Enfermero(a)", "Hospital", "Organización", "Otro",
];

export const ESTADOS_VE = [
  "Amazonas", "Anzoátegui", "Apure", "Aragua", "Barinas", "Bolívar", "Carabobo", "Cojedes",
  "Delta Amacuro", "Distrito Capital", "Falcón", "Guárico", "Lara", "Mérida", "Miranda", "Monagas",
  "Nueva Esparta", "Portuguesa", "Sucre", "Táchira", "Trujillo", "Vargas (La Guaira)", "Yaracuy", "Zulia",
];

export const AFECTADO_OPTS = ["Sí", "No", "Por confirmar"];
export const ESTADO_ACTUAL_OPTS = [
  "Hospitalizado", "Dado de alta", "En recuperación", "En espera de cirugía de amputación",
];
export const SI_NO = ["Sí", "No"];

export const MIEMBRO_OPTS = ["Miembro inferior", "Miembro superior", "Ambos"];
export const LADO_OPTS = ["Derecho", "Izquierdo", "Bilateral"];
export const NIVEL_INFERIOR_OPTS = [
  "Amputación transtibial", "Amputación transfemoral", "Desarticulación de rodilla",
  "Desarticulación de cadera", "Amputación parcial del pie", "Otro",
];
export const NIVEL_SUPERIOR_OPTS = [
  "Amputación transradial", "Amputación transhumeral", "Desarticulación de codo",
  "Desarticulación de hombro", "Amputación parcial de la mano", "Amputación de dedos", "Otro",
];
export const MUNON_OPTS = [
  "Recién amputado", "En proceso de cicatrización", "Cicatrizado", "Con signos de infección", "Por confirmar",
];
export const APOYO_OPTS = ["Sí", "No", "Limitado"];
export const ASISTIR_OPTS = ["Sí", "No", "Requiere apoyo para trasladarse"];

export const CASE_STATUSES = [
  { value: "nuevo", label: "Nuevo", color: "bg-yellow-100 text-yellow-800 border-yellow-300", dot: "bg-yellow-400" },
  { value: "preevaluacion", label: "En preevaluación", color: "bg-orange-100 text-orange-800 border-orange-300", dot: "bg-orange-500" },
  { value: "buscando", label: "Preevaluado — buscando patrocinador", color: "bg-purple-100 text-purple-800 border-purple-300", dot: "bg-purple-500" },
  { value: "patrocinador", label: "Con patrocinador asignado", color: "bg-green-100 text-green-800 border-green-300", dot: "bg-green-500" },
  { value: "entregada", label: "Prótesis entregada", color: "bg-emerald-100 text-emerald-800 border-emerald-300", dot: "bg-emerald-600" },
  { value: "descartado", label: "No elegible / descartado", color: "bg-slate-100 text-slate-700 border-slate-300", dot: "bg-slate-400" },
];

export const PRIORITIES = [
  { value: "Alta", color: "bg-red-100 text-red-700 border-red-300" },
  { value: "Media", color: "bg-amber-100 text-amber-700 border-amber-300" },
  { value: "Baja", color: "bg-slate-100 text-slate-600 border-slate-300" },
];

export function statusMeta(value) {
  return CASE_STATUSES.find((s) => s.value === value) || CASE_STATUSES[0];
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const opts = { timeZone: "America/Caracas", day: "2-digit", month: "2-digit", year: "numeric" };
    return new Intl.DateTimeFormat("es-VE", opts).format(d);
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const opts = { timeZone: "America/Caracas", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return new Intl.DateTimeFormat("es-VE", opts).format(d);
  } catch {
    return iso;
  }
}

// Client-side image compression using canvas. Returns a Blob (~<=1MB, max 1280px).
export async function compressImage(file, maxDim = 1280, quality = 0.75) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      let { width, height } = img;
      if (width > height && width > maxDim) {
        height = Math.round((height * maxDim) / width);
        width = maxDim;
      } else if (height > maxDim) {
        width = Math.round((width * maxDim) / height);
        height = maxDim;
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("compress failed"))), "image/jpeg", quality);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      // HEIC or unsupported: fall back to original file
      resolve(file);
    };
    img.src = url;
  });
}
